import { Container } from "react-bootstrap";
import AllProjectTasksPageView from "../components/AdministratorsComponents/AllProjectTasksPage/AllProjectTasksPageView";
import { Administrator } from "../models/administrator";
import styles from "../styles/ProjectsPage.module.css";
import NotFoundPage from "./NotFoundPage";

interface AdministratorAllProjectTasksPageProps {
    loggedInAdministrator: Administrator | null,
}

const AdministratorAllProjectTasksPage = ({ loggedInAdministrator }: AdministratorAllProjectTasksPageProps) => {
  return (
        <Container className={styles.projectsPage}>
        <>
          { loggedInAdministrator
              ? <AllProjectTasksPageView role={loggedInAdministrator.role}/>
              : <NotFoundPage/>
          }
        </>
      </Container>
    )
}

export default AdministratorAllProjectTasksPage